module.exports = __webpack_public_path__ + "img/shards-dashboards-logo.60a85991.svg";